import React from 'react';
import './Header.scss';
import { Link } from "react-router-dom";
import * as Constants from '../../Constants';

const Header = () => {
    return (
        <div className="header">
            <Link to={Constants.HOME_ROUTE}><h1>Hartmut Piniek</h1></Link>
        </div>
    );
};

export default Header;